<template>
    <div class="specs-left-img w-2/4 pl-6 pt-6" id="specs-inner">
        <img class="pr-spc19" src="../../../assets/images/MX-specs-desktop.jpg" alt="Specs">
    </div>
</template>

<script>
    export default {
        name: "SpecsLeft"
    }
</script>

<style scoped>

</style>